module.exports = new __parcel__URL__("altar.cbaf6e12.webp").toString();